import Descriptions from 'antd/lib/descriptions';
import './index.less';

export default Descriptions;



// WEBPACK FOOTER //
// ./src/elements/descriptions/index.js